import { 
    // Page, 
    Text, 
    View
} from '@react-pdf/renderer';

import { useSystemUtils } from '../../../../hooks/useSystemUtils'

import { styles } from '../styles/styles';

import { capitalizeString, spliceString } from "../../../../utils/formatString";

// package label
export function BodyMainRowStyle1(props){

    const {
        data,
        pageNumber
    } = props

    return (
        <View 
            style={{ 
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',

                borderTopWidth: 1,
                borderTopStyle: 'solid',
                borderTopColor: '#000',
                minHeight: 150
            }}
        >
            <View
                style={{
                    width: '65%',
                    // backgroundColor: 'red'
                }}
            >
                <View
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        padding: 5,
                        // backgroundColor: 'red',
                        // paddingTop: 10,
                        // paddingBottom: 3,
                        // paddingBottom: 10,
                        // paddingVertical: 10,
                        // borderBottomColor: '#000',
                        // borderBottomStyle: 'solid',
                        // borderBottomWidth: 2,
                    }}
                >
                    <View>
                        <Text style={[styles.h9]}>ITEMS</Text>
                        <View>
                            {
                                data.items.map((i, index) => {
                                    return (
                                        <View
                                            key={index}
                                            style={{
                                                display: "flex",
                                                flexDirection: 'row',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <Text style={[styles.h10, {}]}>
                                                {spliceString({ val: i.item_name, maxLength: 20 })}
                                            </Text>
                                            <Text style={[styles.h10, {}]}>
                                                {` x ${parseFloat(i.qty)} ${i.uom_name}`}
                                            </Text>
                                        </View>
                                    )
                                })
                            }
                        </View>
                    </View>
                </View>
            </View>
            <View
                style={{
                    width: '35%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    // backgroundColor: 'yellow',
                    borderLeftWidth: 1,
                    borderLeftStyle: 'solid',
                    borderLeftColor: '#000',
                    padding: 5
                }}
            >
                <View
                    styl={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                    }}
                >
                    <Text style={[styles.h8, { marginBottom: 3 }]}>DOCUMENTS</Text>
                    {
                        data?.documentNos && data.documentNos.map((i, index) => {
                            return (
                                <View key={index}>
                                    <Text style={[styles.h11, styles.textBold]}>
                                        {i}
                                    </Text>
                                </View>
                            )
                        })
                    }
                </View>
                {/* <View style={{ marginTop: 5 }}>
                    <Text style={[styles.h8]}>
                        Packed By {data?.ax_createusername}
                    </Text>
                    <Text style={[styles.h8]}>
                        {data?.ax_createdatetime}
                    </Text>
                </View> */}
            </View>
        </View>
    )

}
